import { FileCheck2, FlaskConical, FileSpreadsheet, FileText, LayoutGrid } from "lucide-react";
import { MAILTO, IMG } from "@/lib/site";

const LOGOS = [
  {
    name: "FDA",
    src: "/logos/fda-registered.svg",
    alt: "FDA Registered — facility infrastructure",
  },
  {
    name: "USDA",
    src: "https://upload.wikimedia.org/wikipedia/commons/e/ea/USDA_organic_seal.svg",
    alt: "USDA Organic — supply-chain support",
  },
  {
    name: "FSSAI",
    src: "https://upload.wikimedia.org/wikipedia/en/e/e2/FSSAI_logo.png",
    alt: "FSSAI — licensed processing support",
  },
  { name: "GMP", src: "/logos/who-gmp-clean.png", alt: "WHO-GMP Certified — Good Manufacturing Practice" },
  { name: "CERT", src: "/logos/onecert-clean.png", alt: "OneCert Certified Organic" },
];

const DOCS = [
  { Icon: FileCheck2, label: ["Batch COA", "Available"] },
  { Icon: FlaskConical, label: ["Micro / Heavy Metals", "/ Pesticide Testing"] },
  { Icon: FileSpreadsheet, label: ["Export", "Documentation"] },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="hero"
      data-testid="hero-section"
      style={{
        "--hero-bg-desktop": `url(${IMG.hero})`,
        "--hero-bg-mobile": "url(/images/hero-mobile.jpg)",
      }}
    >
      <div className="hero-bg" aria-hidden="true" />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="wrap hero-grid">
        <div>
          <div className="eyebrow">From Himalayan source to buyer-ready ingredient supply</div>
          <h1>Sea Buckthorn Ingredient Solutions for Global Brands</h1>
          <p className="lead">
            We manufacture and export sea buckthorn pulp, oils, powders and berry formats for food, nutraceutical,
            supplement, wellness and personal-care companies — backed by traceable sourcing, batch testing and
            export-ready documentation.
          </p>
          <div className="btn-row">
            <a href={MAILTO} className="btn btn-primary" data-testid="hero-request-specs">
              <FileText size={14} /> Request Specifications
            </a>
            <a href="#specs" className="btn btn-secondary" data-testid="hero-view-matrix">
              <LayoutGrid size={14} /> View Product Matrix
            </a>
          </div>
          <div className="trust-line">
            Pulp · Purée · Fruit Oil · Seed Oil · Whole Berry Oil · Powder · Dried Berries
            <em>— supporting softgels, gummies, beverages, supplements, beauty and personal care formats</em>
          </div>
        </div>

        <aside className="confidence-card" data-testid="confidence-card">
          <div className="logo-badge-grid logo-badge-grid-5">
            {LOGOS.map((l) => (
              <div
                key={l.name}
                className="logo-badge"
                data-testid={`hero-logo-${l.name.toLowerCase()}`}
                title={l.alt}
              >
                <img src={l.src} alt={l.alt} loading="lazy" />
              </div>
            ))}
          </div>

          <div className="doc-row doc-row-3">
            {DOCS.map(({ Icon, label }, i) => (
              <div className="doc-col" key={i} data-testid={`doc-col-${i}`}>
                <Icon size={32} strokeWidth={1.6} />
                <div className="doc-col-label">
                  {label.map((line, j) => (
                    <div key={j}>{line}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="trust-tag" data-testid="trust-tag">
            Consistent quality. Transparent supply. Global trust.
          </div>
        </aside>
      </div>
    </section>
  );
}
